import { SeeOffersSection, SafeTag, Likert } from '@itau-loans-www/components'
import { useLead } from '@itau-loans-www/hooks'

import Layout from '../../layouts/Summary'
import '../final-screen.scss'
import './fgts-ineligible.scss'

const FgtsIneligible = () => {
  const {
    leadData: { partner }
  } = useLead()

  return (
    <Layout>
      <div className="final_screen">
        <SafeTag />
        <div className="final_screen__content">
          <h1 className="final_screen__title --fgts">
            Não identificamos uma oferta de Saque Aniversário disponível para
            você
          </h1>
        </div>
        <SeeOffersSection
          trackClick="VerOutrasOfertas_2"
          isDenied
          partner={partner}
        />
        <Likert />
      </div>
    </Layout>
  )
}

export default FgtsIneligible
